<template>
  <el-scrollbar class="scroll-bar">
    <el-tree
      ref="tree"
      class="tree-content"
      :data="treeData"
      :expand-on-click-node="false"
      node-key="workShopGroupCode"
      :default-expanded-keys="expandedKeys"
      render-after-expand
      :props="treeProps"
      :default-expand-all="true"
      :highlight-current="true"
      @node-click="handleNodeClick"
    >
      <!-- :filter-node-method="filterNode" -->
      <template slot-scope="{ node, data }">
        <element-tree-line
          :node="node"
          :showLabelLine="true"
          :indent="16"
          class="tree-line"
        >
          <span class="custom-tree-node">
            <span
              :title="data.workShopGroupName"
              class="tree-label"
              :class="data.workShopGroupCode === currentNode ? 'hide' : ''"
              >{{ data.workShopGroupName }}</span
            >
            <span
              v-if="data.workShopGroupCode === currentNode"
              class="tree-btn"
            >
              <div class="area-operator" @click="stop">
                <el-button
                  type="text"
                  class="el-icon-plus"
                  size="mini"
                  v-auth="'/workshop/emergency-group:add'"
                  title="新增"
                  @click="() => addGroup(node, data)"
                ></el-button>
                <el-button
                  type="text"
                  class="el-icon-edit-outline"
                  size="mini"
                  v-auth="'/workshop/emergency-group:update'"
                  title="修改"
                  @click="() => editGroup(node, data)"
                ></el-button>
                <el-button
                  v-if="data.parentCode !== '-1'"
                  type="text"
                  class="el-icon-delete-solid"
                  size="mini"
                  v-auth="'/workshop/emergency-group:delete'"
                  @click="() => deleteGroup(node, data)"
                  title="删除"
                ></el-button>
              </div>
            </span>
          </span>
        </element-tree-line>
      </template>
    </el-tree>
    <workshop-group-modal ref="workshopModal"></workshop-group-modal>
  </el-scrollbar>
</template>

<script>
import ElementTreeLine from "element-tree-line";
import WorkshopGroupModal from "./workshopGroupModal";
export default {
  components: {
    WorkshopGroupModal,
    ElementTreeLine,
  },
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
    treeProps: {
      type: Object,
      default: () => ({
        children: "workShopGroupChildren",
        label: "workShopGroupName",
        isLeaf: "isLeaf",
      }),
    },
  },
  data() {
    return {
      // treeProps: {
      //   children: "workShopGroupChildren",
      //   label: "workShopGroupName",
      //   isLeaf: "isLeaf",
      // },
      currentNode: "",
      expandedKeys: [],
    };
  },
  watch: {
    treeData: {
      handler(newVal) {
        console.log(newVal, "newVal");
        this.$nextTick(() => {
          this.expandedKeys = [newVal[0].workShopGroupCode];
          this.$refs.tree.setCurrentKey(newVal[0].workShopGroupCode);
        });
      },
      deep: true,
    },
  },
  methods: {
    stop(e) {
      e.stopPropagation();
    },
    addGroup(node, data) {
      const { workShopGroupCode } = data;
      // "parentCode": "200000001",                      // 父节点code
      // "workShopDirector": "顾涛",                     // 车间主任
      // "workShopDirectorPhone": "15865421235",         // 车间主任手机号码
      // "workShopGroupName": "一车间",                  // 车间应急组名称
      // "workShopLeader": "张三",                       // 车间班组长
      // "workShopLeaderPhone": "15965488520",           // 车间班组长手机号码
      // "workShopTelephone": "42998521"
      //  workShopGroupCode : parentCode
      this.$emit("on-group-add", workShopGroupCode);
    },
    deleteGroup(node, data) {
      const { workShopGroupCode } = data;
      this.$emit("on-group-delete", data);
    },
    editGroup(node, data) {
      const { hasLeaf, workShopGroupChildren, $treeNodeId, ...rest } = data;
      this.$emit("on-group-update", rest);
    },
    handleNodeClick(data, node, component) {
      // console.log(node);
      const { workShopGroupCode } = data;
      this.currentNode = workShopGroupCode;
      this.$emit("node-click", data);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@src/common/assets/style/mixin";
.custom-tree-node {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  .tree-label {
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hide {
    max-width: 60% !important;
  }
  .tree-btn {
    position: absolute;
    right: 0;
  }
  .area-operator {
    display: inline-block;
    margin: 0 20px;
    .el-button {
      // color: #fff !important;
    }
  }
  .tree-icon {
    margin-right: 2px;
    @include set_theme_color(color, font-active-color);
  }
  .node-title {
    margin-bottom: -2px;
    display: inline-block;
    // width: 145px;
    margin-left: 4px;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // overflow: hidden;
    // word-break: break-all;
  }
}
.scroll-bar {
  height: 100%;
  // padding-bottom: 10px;
  .tree-content {
    padding: 5px 0;
    /deep/.el-tree-node__content {
      &:hover {
        // @include set_theme_color(background-color, main-theme-color);
        .el-button--text {
          color: #fff;
        }
      }
    }
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 100%;
    margin-bottom: 0px !important;
  }
}
</style>
